<template>
  <div>
    <InstantChangeAlert/>
    <DashHead :asset="asset" :currency="currency" :second="second" :color="color" />
    <v-progress-linear v-slot:progress color="success"></v-progress-linear>

    <div grid-list-md id="order_section">
      <div class="ma-2">
        <v-layout row wrap justify-space-between class="mb-2">
          <v-flex xs12 md1>
            <div>
              <!-- <vs-card>
                <div slot="header">
                  <h3>Markets</h3>
                </div>
                
              </vs-card> -->
              <v-card>
                <v-card-title class="market_card_title white--text">
                 <v-flex xs12 hidden-sm-and-down>
                    <span >Markets</span>
                  </v-flex>
                  <v-flex xs12 hidden-md-and-up>
                    <span >
                        <img  src="/img/ethereum.svg" class="ml-4" width="25" alt="ethereum"><h1 class="ml-4" style="display:inline-block">ETHEREUM-CFA</h1>
                    </span>
                  </v-flex>
                </v-card-title>
                 </v-card>
                <v-divider></v-divider>
                <v-divider></v-divider>
                <v-divider></v-divider>
                <v-divider></v-divider>
                
                  <v-layout row wrap>
                          <v-flex xs3 md12 text-xs-left v-for="item in markets" :key="item.id">
                            <div class="markets ">
                              <span class="pair" @click="$router.push(item.href)" >{{item.title}} </span>
                            </div>
                          </v-flex>
                        </v-layout>
                
             

            </div>
          </v-flex>
          <v-flex xs12 sm4 class="buy-sell-form #607D8B blue-grey" style>
            <v-layout row wrap>
              <v-flex xs12>

                <BuySellForm :asset="asset" :currency="currency" :second="second" />
                
              </v-flex>
              <v-flex xs12 class="hidden-sm-and-down">
                <MyOrders :asset="asset" :currency="currency" :second="second" />
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 sm7 class="orderbook pl-1 #607D8B blue-grey">
            <v-card>
              <v-card-title class="mt-1 font-weight-bold white--text">Carnet d'ordre</v-card-title>
            </v-card>
            <v-layout row wrap>
              <v-flex xs12 md6 class="pb-2 mb-2">
                <OrderBookBuy :asset="asset" :currency="currency" :second="second"/>
              </v-flex>
              <v-flex xs12 md6 class="pl-lg-2 pl-md-2 mb-2">
                <OrderBookSell :asset="asset" :currency="currency" :second="second" />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <div class="hidden-md-and-up">
          <MyOrders :asset="asset" :currency="currency" :second="second"/>
        </div>

        <Transactions :asset="asset" :currency="currency" :second="second" />
        <br />
      </div>
    </div>
  </div>
</template>

<script>
const BuySellForm = () => import("../components/eth/BuySellForm");
import OrderBookBuy from "../components/eth/OrderBookBuy";
import OrderBookSell from "../components/eth/OrderBookSell";
const MyOrders = () => import("../components/MyOrders");
import Transactions from "../components/Transactions";
const DashHead = () => import("../components/DashHead_eth_cfa");
import axios from "axios";
import firebase from "../fb";
export default {
  name: "Dashboard",
  components: {
    OrderBookBuy,
    BuySellForm,
    OrderBookSell,
    MyOrders,
    Transactions,
    DashHead
  },
data() {
  return {
    asset:'crypto',
    currency:'eth',
    second:'cfa',
    color:'#6492D4',
    markets:[
          {id:1, title:'BTC/CFA', href:'/dashboard'},
          // {id:2, title:'BTC/GHS', href:'/dashboard/BTC-GHS'},
          // {id:3, title:'ETH/CFA', href:'/dashboard/ETH-CFA'},
          {id:4, title:'PM/CFA', href:'/dashboard/PM-CFA'},
           {id:5, title:'ETH/CFA', href:'/dashboard/ETH-CFA'},
        ],
  }
},
  mounted() {
    const autoLogout=()=>{
      var minutes = true; // change to false if you'd rather use seconds
      var interval = minutes ? 60000 : 1000;
      var IDLE_TIMEOUT = 15; // 15 minutes in this example
      var idleCounter = 0;
      document.onmousemove = document.onkeypress = document.onmousedown = document.ontouchmove = document.mousewheel = function() {
        idleCounter = 0;
      };
      window.setInterval(function() {
        if (++idleCounter >= IDLE_TIMEOUT) {
          firebase
            .auth()
            .signOut()
            .then(function() {
              location.replace("/");
              // Sign-out successful.
            })
            .catch(function(error) {
              console.log(error);

              // An error happened.
            });
        }
      }, interval);
    }
    autoLogout()
  },

  watch: {
    "$route.params.dashboard"() {
      this.init();
    }
  },
  methods: {
    hi(item) {
      console.log(item.href);
      this.$router.push(item.href);
      
    }
  },
};
</script>

<style scoped>
div.v-card__title {
  background-color:  #003449;
}
span.v-chip__content{
  cursor: pointer;
}
div.markets{
  width: 100%;
  max-height: 125px;
  border: 5px white solid;
  background-color: #607D8B;
}
span.pair{
  display: block;
  margin: 5px auto;
  width: 80%;
  border: 1px  solid #000;
  border-radius: 5px 5px;
  cursor: pointer;
  text-align: center;
  color: white;
  padding:5px;
  background-color: #003449;
}
span.v-chip.font-weight-bold.v-chip_href.theme--light{
  background-color: palegoldenrod;
}
span.v-chip__content{
  cursor: pointer;
}
</style>
